module.exports = __webpack_public_path__ + "static/ttl-pan-card-325a6b7c0e3ab1db8affe1ce0664a9b3.pdf";